const loginAndSignUp = {
  loginTips: "هل تمتلك حسابًا على HitPaw؟ <1>تسجيل الدخول</1>",
  loginSuccessTips: "تسجيل الدخول بنجاح",
  loginErrorTips: "فشل تسجيل الدخول",
  loginAccountOrPasswordErrorTips: "بريدك الإلكتروني أو كلمة سرك غير صحيحة. يرجى المحاولة مجددًا.",
  loginAccountNotExitErrorTips: "البريد الإلكتروني غير مسجل",
  signUpTips: "هل أنت مستخدم غير مسجل بعد؟",
  rememberMe: "تذكرني",
  forgotPassword: "هل نسيت كلمة السر؟",
  forgotPasswordTitle: "نسيت كلمة السر",
  verifyEmailBtn: "تأكيد البريد الإلكتروني",
  resetPasswordTitle: "إعادة تعيين كلمة السر",
  resetPasswordLabel: "يرجى إعادة تعيين كلمة سرك",
  resetPasswordPlaceholder: "أدخل كلمة سر جديدة",
  resetPasswordSuccessTips: "تمت إعادة تعيين كلمة السر بنجاح",
  signUpPrivacyTips: "باشتراكك فإنك توافق على <1>خدمات الاستخدام</1> و<3>سياسة الخصوصية</3>",
  loginPrivacyTips: "بتسجيل الدخول، فإنك توافق على <1>خدمات الاستخدام</1> و<3>سياسة الخصوصية</3>",
  signUpSuccessTips: "تم تسجيل حسابك بنجاح!",
  getCode: "احصل على رمز",
  getCodeSuccessTips: "تم إرساله إلى صندوق بريدك الإلكتروني، يرجى التحقق من ذلك",
  verificationSuccessTips: "نجح التحقق من عنوان البريد الإلكتروني",
  surveyTitle: "مرحبًا بك في HitPaw Online",
  surveyStep1: "<1>الخطوة 1 /3</1>",
  surveyStep2: "<1>الخطوة 2 /3</1>",
  surveyStep3: "<1>الخطوة 3 /3</1>",
  surveyQuestion: "ما هو غرضك من استخدام HitPaw؟",
  surveyThemeQuestion: "اختر الوضع الذي تحبه",
  surveyAnswerOther: "أخرى",
  surveyAnswer1: "فيديو نمط الحياة",
  surveyAnswer2: "فيديو الأعمال",
  surveyAnswer3: "فيديو الشركات",
  surveyAnswer4: "فيديو التسويق",
  surveyAnswer5: "فيديو وسائل التواصل الاجتماعي",
  surveyAnswer6: "فيديو عرض الشرائح",
  surveyAnswer7: "أدوات الفيديو",
  surveyAnswer8: "فيديو السفر",
  surveyAnswer9: "فيديو الزفاف",
  surveyAnswer10: "فيديو عيد ميلاد",
  surveyAnswer11: "فيديو أطفال",
  surveyAnswer12: "فيديو حيوانات",
  surveyAnswer13: "فيديو طعام",
  surveyAnswer14: "فيديو أزياء",
  surveyAnswer15: "فيديو إجازة",
  surveyAnswer16: "فيديو رياضة",
  surveyAnswer17: "فيديو تصوير فوتوجرافي",
  surveyAnswer18: "فيديو موسيقى",
  surveyAnswerLightMode: "الوضع المظلم",
  surveyAnswerDarkMode: "الوضع المضيء",
  surveyNextBtn: "التالي",
  surveyBackBtn: "رجوع",
  surveyDoneBtn: "تم",
  surveyStartBtn: "ابدأ",
  logoutWarnTips: "هل أنت متأكد أنك ترغب في تسجيل الخروج؟",
  ContinuewithGoogle: 'تواصل مع جوجل',
  Securityverification: 'التحقق من الأمن',
  youraccount: 'حسابك',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    ' موجود بالفعل ، لضمان أمان حسابك ، يرجى إكمال التحقق أولاً.',
};

export default loginAndSignUp;
